function Step5Svg() {
    return (
        <svg width='129' height='102' viewBox='0 0 129 102' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <ellipse cx='80.5968' cy='62' rx='39.403' ry='40' fill='#FFEDF3' />
            <circle cx='80.5967' cy='61.4028' r='30.4478' fill='#FFD1E1' />
            <path
                d='M93.8993 53.7798C93.3156 53.459 92.0913 53.1236 90.4257 54.3194L88.333 55.8361C88.1764 51.3007 86.2545 49.5215 81.5851 49.5215H73.0434C68.1747 49.5215 66.2812 51.4611 66.2812 56.4486V68.1152C66.2812 71.4694 68.0608 75.0423 73.0434 75.0423H81.5851C86.2545 75.0423 88.1764 73.2631 88.333 68.7277L90.4257 70.2444C91.3083 70.8861 92.0771 71.0902 92.6892 71.0902C93.216 71.0902 93.6288 70.9298 93.8993 70.784C94.483 70.4777 95.4653 69.6465 95.4653 67.5611V57.0027C95.4653 54.9173 94.483 54.0861 93.8993 53.7798ZM79.4497 61.3777C77.9833 61.3777 76.7733 60.1527 76.7733 58.6361C76.7733 57.1194 77.9833 55.8944 79.4497 55.8944C80.916 55.8944 82.126 57.1194 82.126 58.6361C82.126 60.1527 80.916 61.3777 79.4497 61.3777Z'
                fill='#ED236B'
            />
            <circle cx='6' cy='6' r='6' transform='matrix(-1 0 0 1 12 15)' fill='#C6C3FB' />
            <circle cx='4' cy='4' r='4' transform='matrix(-1 0 0 1 64 0)' fill='#FED883' />
            <circle cx='2' cy='2' r='2' transform='matrix(-1 0 0 1 20 75)' fill='#651FFF' />
            <circle cx='3' cy='3' r='3' transform='matrix(-1 0 0 1 129 85)' fill='#FEB5BD' />
        </svg>
    );
}

export default Step5Svg;
